import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { loginSpecialCharValidator } from '../../../shared/validators/FormValidator';
import "../../../assets/loginAssets/loginStyles.css";
import welcomelogo3 from "../../../assets/loginAssets/logos/welcomelogo3.png";
import immlogo from "../../../assets/loginAssets/logos/immlogo.png";
import { createNotification } from '../../../shared/components/Popup';
import { basicApi } from '../../../shared/services/apiService';
import {
  setLoginInfo,
  setTabID,
  setToken,
  setRefreshToken,
} from '../../../shared/utils/storage';
import { messages } from '../../../shared/constants/messages';
// import OnlinePrintETD from "./pdf/OnlinePrintETD";

const allowedEtdRoles = [
  "ETD_assessor",
  "ETD_Approval",
  "ETD_Manager",
  "ETD_administrator",
  "ETD_STATION_ADMIN",
];

function Login() {
  // useEffect(() => {
  //   setTabID()
  // }, []);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});

  const loginForm = {
    SystemId: "UHM002",
    username,
    password,
  };

  const findFormErrors = () => {
    const { password, username } = loginForm;
    const newErrors = {};
    if (!password || password === "")
      newErrors.password = "password is required!";
    if (!username || username === "") {
      newErrors.username = "Username is required!";
    } else {
      const specialCharError = loginSpecialCharValidator(username);
      if (specialCharError) newErrors.username = specialCharError;
    }
    return newErrors;
  };
  const handleLogin = async (e) => {
    setTabID();
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
      setLoading(true);

      const loginData = { username, password };
      basicApi(loginData, "auth/login")
        .then((result) => {
          if (result.code === 1) {
            const userRoles = result?.data?.user?.Roles || [];
            const hasAllowedEtdRole = userRoles.some((role) =>
              allowedEtdRoles.includes(role?.RoleCode),
            );

            if (!hasAllowedEtdRole) {
              const info = {
                type: "error",
                message: "you dont have role to this system",
              };
              createNotification(info)();
              return;
            }

            setLoginInfo(result?.data);
            setToken(result?.data?.access_token);
            setRefreshToken(result?.data?.refresh_token);
            navigate("/etd");
            // const info = { type: "success", message: result.message };
            // createNotification(info)();
          } else {
            const info = { type: "error", message: result.message };
            createNotification(info)();
          }
        })
        .catch(() => {
          const info = { type: "error", message: messages.technicalError };
          createNotification(info)();
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      {/* <OnlinePrintETD /> */}

      <div className="fontRegular custom-background">
        <table style={{ width: "100%", height: "100%" }}>
          <tbody>
            <tr style={{ width: "100% !important", height: "100% !important" }}>
              <td style={{ width: "50%", height: "100%" }}>
                <div className="Container80">
                  <img src={welcomelogo3} alt="" className="Fcenter" />
                </div>
              </td>
              <td
                style={{
                  width: "50%",
                  height: "100%",
                  verticalAlign: "middle",
                }}
              >
                <div className="Container80Right">
                  <div
                    className="Container80 MaxWid400 white-back Fnone BordRad10 Fright"
                    id="login-box"
                  >
                    <div
                      className="Container"
                      style={{ backgroundColor: "#1578c9" }}
                    >
                      <div className="EmptyBox10"></div>
                      <div
                        className="Container70"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="Container20"> </div>
                        <div className="Container80 Fnone MarAuto Fs20 white">
                          <font size="4" face="Cambria">
                            <b>LOGIN</b>
                          </font>
                        </div>
                        <div className="EmptyBox5"></div>
                        <div className="Container20"> </div>
                        <div className="Container80 Fnone MarAuto white">
                          <font size="4" face="Cambria">
                            {/* Welcome to IIAS  */}
                          </font>
                        </div>
                      </div>
                      <div
                        className="Container25 TexAlCenter Animated05 left "
                        role="1"
                        style={{ backgroundColor: "#1578c9" }}
                      >
                        <img src={immlogo} className="Fright" alt="logo" />
                      </div>
                      <div className="EmptyBox10"></div>
                    </div>
                    <div className="EmptyBox20"></div>
                    <div className="Container">
                      <center style={{ color: "blue" }}></center>
                      <center style={{ color: "red" }}></center>
                      <br />
                      <Form>
                        <Form.Control
                          style={{
                            textAlign: "center",
                            marginLeft: "15%",
                            width: "70%",
                            borderRadius: "3px",
                          }}
                          type="text"
                          value={username}
                          name="Username"
                          autoComplete="new-password"
                          placeholder="Email"
                          isInvalid={!!errors.username}
                          onChange={(e) => setUsername(e.target.value)}
                          required
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{
                            textAlign: "center",
                            marginRight: "15%",
                            color: "red",
                          }}
                        >
                          {errors.username}
                        </Form.Control.Feedback>
                        <br />
                        <Form.Control
                          style={{
                            textAlign: "center",
                            marginLeft: "15%",
                            width: "70%",
                            borderRadius: "3px",
                          }}
                          type="password"
                          value={password}
                          name="Password"
                          autoComplete="new-password"
                          placeholder="Password"
                          isInvalid={!!errors.Password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{
                            textAlign: "center",
                            marginRight: "15%",
                            color: "red",
                          }}
                        >
                          {errors.Password}
                        </Form.Control.Feedback>
                        <br />

                        <div style={{ marginLeft: "140px", color: "red" }}>
                          {error}
                        </div>
                        <div
                          className="m-reset-0 required"
                          style={{ marginTop: "5px" }}
                        >
                          <div>
                            <input
                              type="submit"
                              className="btn btn-block btn-label-next"
                              variant="contained"
                              color="primary"
                              value={loading ? "Loading..." : "Login"}
                              onClick={handleLogin}
                              disabled={loading}
                              style={{
                                marginLeft: "15%",
                                marginBottom: "10px",
                                width: "70%",
                                backgroundColor: "#3f51b5",
                                color: "#fff",
                                borderRadius: "3px",
                              }}
                            />
                            <p
                              style={{
                                marginLeft: "20%",
                                width: "60%",
                                textAlign: "right",
                                marginTop: "5px",
                                marginBottom: "20px",
                                fontSize: "15px",
                              }}
                            >
                              <br />
                              <Link to="/forgot-password">Reset Password?</Link>
                            </p>
                            <p
                              style={{
                                marginLeft: "10px",
                                textAlign: "center",
                              }}
                            >
                              <small>V1.2.04</small>
                            </p>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default Login;
